import { PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '27be4cf4-d1d6-46cc-8ce5-ea67c9aa9c96';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '1a63eded-aece-4b7f-a3d7-39828b274d9b';

export const msalConfig = {
  auth: {
    clientId,
    authority:                `https://login.microsoftonline.com/${tenantId}`,
    redirectUri:              window.location.origin,
    // After redirect login, go to root (not the original /login URL)
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation:          'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

let _instance    = null;
let _initialized = false;
let _redirectResult = null; // Captured once from handleRedirectPromise()

export async function getMsalInstance() {
  if (!_instance) {
    _instance = new PublicClientApplication(msalConfig);
  }
  if (!_initialized) {
    await _instance.initialize();
    _initialized = true;
    // MSAL v5 requires an explicit handleRedirectPromise() call after initialize().
    // This processes the auth code when the browser returns from Microsoft login.
    _redirectResult = await _instance.handleRedirectPromise().catch(() => null);
  }
  return _instance;
}

/**
 * Returns the MSAL auth result from a loginRedirect() flow (consumed once).
 * Returns null if the app was not loaded as a result of a Microsoft redirect.
 */
export function consumeMsalRedirectResult() {
  const result = _redirectResult;
  _redirectResult = null;
  return result;
}
